// frontend/src/api/projectsV2.js
// API client for v2 Projects (first-class Project model)

import api from './axiosConfig';

// ✅ FIX: Use shared axios with absolute paths
// This prevents any baseURL composition issues
export const ProjectsAPI = {
  // Projects CRUD
  create: (payload) => api.post('/api/v2/projects', payload),
  list: (params) => api.get('/api/v2/projects', { params }),
  get: (id, params) => api.get(`/api/v2/projects/${id}`, { params }),
  update: (id, payload) => api.patch(`/api/v2/projects/${id}`, payload),
  archive: (id) => api.delete(`/api/v2/projects/${id}`),
  unarchive: (id) => api.post(`/api/v2/projects/${id}/unarchive`),
  star: (id, starred) => api.patch(`/api/v2/projects/${id}/star`, { starred }),

  // Sharing
  share: (id, visibility) => api.post(`/api/v2/projects/${id}/share`, { visibility }),
  unshare: (id) => api.delete(`/api/v2/projects/${id}/share`),

  // Conversion - CRITICAL FIX
  convertFromSession: (sessionId) =>
    api.post(`/api/v2/projects/convert-from-session/${sessionId}`),

  // Note
  getNote: (id) => api.get(`/api/v2/projects/${id}/note`),
  putNote: (id, note) => api.put(`/api/v2/projects/${id}/note`, { note }),

  // Attachments (legacy)
  getAttachments: (id) => api.get(`/api/v2/projects/${id}/attachments`),
  addAttachment: (id, body) => api.post(`/api/v2/projects/${id}/attachments`, body),
  deleteAttachment: (id, attachmentId) => api.delete(`/api/v2/projects/${id}/attachments/${attachmentId}`),

  // Files (V2 - ProjectAttachment documents)
  deleteFile: (id, fileId) => api.delete(`/api/v2/projects/${id}/files/${fileId}`),

  // Tasks
  listTasks: (id, params) => api.get(`/api/v2/projects/${id}/tasks`, { params }),
  createTask: (id, payload) => api.post(`/api/v2/projects/${id}/tasks`, payload),
  updateTask: (id, taskId, payload) => api.patch(`/api/v2/projects/${id}/tasks/${taskId}`, payload),
  deleteTask: (id, taskId) => api.delete(`/api/v2/projects/${id}/tasks/${taskId}`),

  // Membership
  listMembers: (id) => api.get(`/api/v2/projects/${id}/members`),
  addMember: (id, payload) => api.post(`/api/v2/projects/${id}/members`, payload),
  updateMember: (id, memberUid, payload) => api.patch(`/api/v2/projects/${id}/members/${memberUid}`, payload),
  removeMember: (id, memberUid) => api.delete(`/api/v2/projects/${id}/members/${memberUid}`),

  // Session Linking (Projects-Sessions separation)
  listLinkedSessions: (id) => api.get(`/api/v2/projects/${id}/sessions`),
  linkSession: (id, payload) => api.post(`/api/v2/projects/${id}/sessions`, payload),
  createAndLinkSession: (id, payload) => api.post(`/api/v2/projects/${id}/sessions/create`, payload),
  unlinkSession: (id, sessionId) => api.delete(`/api/v2/projects/${id}/sessions/${sessionId}`),

  // Content Creation
  createNote: (id, payload) => api.post(`/api/v2/projects/${id}/notes`, payload),
  createVoice: (id, payload) => api.post(`/api/v2/projects/${id}/voices`, payload),
  uploadFile: (id, formData) => api.post(`/api/v2/projects/${id}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  createObjective: (id, payload) => api.post(`/api/v2/projects/${id}/objectives`, payload),
  createDeliverable: (id, payload) => api.post(`/api/v2/projects/${id}/deliverables`, payload)
};

export default ProjectsAPI;
